import { render, staticRenderFns } from "./BdThreadRobot.vue?vue&type=template&id=26f46dbb&"
import script from "./BdThreadRobot.vue?vue&type=script&lang=js&"
export * from "./BdThreadRobot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports